import classNames from "classnames";
import React from "react";
import { SanityImageSourceExt } from "../models/shared/SanityImageSourceExt";
import { isNullOrWhiteSpace, replaceWithUnicode, truncateString } from "../shared/string";
import SanityImage from "./SanityImage";
import SanityLink from "./SanityLink";

export interface ReferenceCardProps {
  id: string;
  introText?: string;
  thumbnail?: SanityImageSourceExt;
  title?: string;
}

const ReferenceCard: React.FC<ReferenceCardProps> = ({
  id,
  introText,
  thumbnail,
  title
}) => (
  <li>
    <SanityLink
      className={classNames(
        "no-underline card-basic group flex-1 min-w-card-small items-center p-4 cursor-pointer h-full",
        "hover:border-brand-primary-70",
        "focus:outline-none focus:shadow-card-outline"
      )}
      isExternalLink={false}
      reference={{
        _id: id
      }}
    >
      <div className="flex flex-col lg:flex-row h-full w-full">
        <SanityImage
          className="rounded-md w-36 h-28 object-cover mb-2 lg:mb-0"
          image={thumbnail}
          loading="lazy"
          width={150}
          height={120}
        />

        <div className="lg:ml-4">
          {!isNullOrWhiteSpace(title) && (
            <h4 className="text-xl pb-1 font-bold text-blog-primary-20">
              {replaceWithUnicode(title)}
            </h4>
          )}

          {!isNullOrWhiteSpace(introText) && (
            <p className="text-neutral-20 text-base">{truncateString(introText, 35)}</p>
          )}
        </div>
      </div>
    </SanityLink>
  </li>
);
export default ReferenceCard;
